import { useVyStepper } from '../../../../../../../../hooks/use-vy-stepper';
import {
  RenewContractStepFlowConfig,
  RenewContractStepViewConfig,
} from '../renew-contract-dialog-types/renew-contract-step-view-config';
import {
  RENEW_CONTRACT_TERMS_STEPS,
  RenewContractTermsStep,
} from '../renew-contract-dialog-types/renew-contract-terms-steps';
import { RenewContractSameTermsStepDetails } from '../renew-contract-dialog-components/RenewContractSameTermsStepDetails';
import { useNavigate } from 'react-router-dom';
import { getOptionalObjectProperty, Optional } from '@vy/utils';

export function useRenewContractSameTermsFlow(contractId: string): RenewContractStepFlowConfig {
  const stepper = useVyStepper<RenewContractTermsStep>(
    RENEW_CONTRACT_TERMS_STEPS.Details,
    RENEW_CONTRACT_TERMS_STEPS,
  );
  const navigate = useNavigate();

  const stepViewMap: Record<RenewContractTermsStep, RenewContractStepViewConfig> = {
    [RENEW_CONTRACT_TERMS_STEPS.Details]: {
      label: 'Renew contract with updated terms',
      ctaText: 'Go to plan builder',
      content: <RenewContractSameTermsStepDetails />,
      onNext: () => {
        navigate(`/plans/contracts/${contractId}/revise?planCreateReason=ReviseContractForRenewal`);
        stepper.nextStep();
      },
    },
  };

  const getStepView = (step: RenewContractTermsStep): Optional<RenewContractStepViewConfig> => {
    return getOptionalObjectProperty(stepViewMap, step);
  };

  return {
    getStepView,
    isFirstStep: stepper.isFirstStep,
    goToPreviousStep: stepper.previousStep,
    currentStep: stepper.currentStep,
  };
}
